export const HOUSE_SLUG = 'house'